// extracted by mini-css-extract-plugin
export default {"agences":"agencies_agences__KOQNW","container":"agencies_container__+XAYC","header":"agencies_header__X61St","titleEntity":"agencies_titleEntity__Zg9P3"};